export default __webpack_public_path__ + "static/media/pencil-waitlist.73f59c6f.svg";